import { omit } from 'lodash';
import { post } from './utils';

export async function banCustomerApi(data) {
  return post(`/customers/bans/${data?.customerId}`, omit(data, 'customerId'));
}
